module.exports = __webpack_public_path__ + "static/img/rank_background.bc0172f7.png";